export default function ComparisonSection() {
  return (
    <section className="py-20 md:py-28 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        {/* Header */}
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-14 md:mb-20">
          <div className="flex-1">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight">
              Por que somos
              <br />
              diferentes?
            </h2>
          </div>
          <div className="flex-1 max-w-md">
            <p className="text-foreground-500 text-base leading-relaxed">
              Nem todos os spreadsheets são iguais. Veja por que o cssbuy spreadsheet é a melhor escolha para compradores que buscam qualidade, segurança e atualização constante.
            </p>
          </div>
        </div>

        {/* Comparison Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
          {/* Our Spreadsheet - Dark Card */}
          <div className="rounded-2xl bg-foreground-950 p-6 md:p-7 flex flex-col">
            <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-500/20 text-accent-300 text-xs font-semibold w-fit mb-4">
              <i className="ri-star-fill text-xs"></i>
              Recomendado
            </span>
            <h3 className="text-background-50 font-bold text-xl mb-3">Nosso Spreadsheet</h3>
            <p className="text-background-50/60 text-sm mb-6 leading-relaxed">
              O cssbuy spreadsheet mais completo do Brasil, com produtos verificados e organizados em categorias exclusivas.
            </p>
            <div className="mt-auto bg-background-50/5 rounded-xl p-4">
              <img
                src="https://readdy.ai/api/search-image?query=Organized%20digital%20product%20catalog%20displayed%20on%20modern%20curved%20monitor%20with%20colorful%20thumbnail%20grid%2C%20clean%20tech%20workspace%20with%20warm%20ambient%20lighting%2C%20productive%20evening%20atmosphere%2C%20sleek%20desk%20setup%20with%20mechanical%20keyboard%2C%20professional%20ecommerce%20dashboard%20view%2C%20warm%20amber%20screen%20glow%2C%20premium%20tech%20lifestyle%20photography%2C%20organized%20data%20visualization&width=500&height=350&seq=comp-v2-ours&orientation=landscape"
                alt="CSSBuy Spreadsheet organizado"
                className="w-full h-48 object-cover object-top rounded-lg"
                loading="lazy"
              />
            </div>
            <ul className="mt-5 space-y-2.5">
              {[
                '3000+ produtos verificados',
                'Atualização diária',
                '40+ categorias organizadas',
                'Links verificados manualmente',
                'Guias completos de segurança',
                'Comunidade ativa no Brasil',
              ].map((item, i) => (
                <li key={i} className="flex items-start gap-2.5 text-background-50/70 text-sm">
                  <i className="ri-check-line text-accent-400 mt-0.5 shrink-0"></i>
                  {item}
                </li>
              ))}
            </ul>
          </div>

          {/* Generic Spreadsheets */}
          <div className="rounded-2xl bg-background-50 p-6 md:p-7 flex flex-col">
            <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-semibold w-fit mb-4">
              <i className="ri-file-list-3-line text-xs"></i>
              Outros
            </span>
            <h3 className="text-foreground-900 font-bold text-xl mb-3">Planilhas Genéricas</h3>
            <p className="text-foreground-500 text-sm mb-6 leading-relaxed">
              Planilhas básicas sem organização adequada, difíceis de navegar e raramente atualizadas.
            </p>
            <div className="mt-auto bg-background-100 rounded-xl p-4">
              <img
                src="https://readdy.ai/api/search-image?query=Cluttered%20messy%20desk%20with%20stacks%20of%20printed%20spreadsheets%20and%20sticky%20notes%20everywhere%2C%20chaotic%20office%20workspace%2C%20harsh%20overhead%20fluorescent%20lighting%2C%20disorganized%20paper%20piles%2C%20spilled%20coffee%20cup%2C%20scattered%20highlighters%20and%20pens%2C%20stressful%20work%20environment%2C%20messy%20paperwork%20photography%2C%20cold%20blue%20tinted%20light%2C%20overwhelming%20clutter%20composition&width=500&height=350&seq=comp-v2-generic&orientation=landscape"
                alt="Planilhas genéricas"
                className="w-full h-48 object-cover object-top rounded-lg"
                loading="lazy"
              />
            </div>
            <ul className="mt-5 space-y-2.5">
              {[
                '500+ produtos apenas',
                'Atualização semanal ou menos',
                '10+ categorias básicas',
                'Links não verificados',
                'Sem guias de segurança',
                'Sem suporte à comunidade',
              ].map((item, i) => (
                <li key={i} className="flex items-start gap-2.5 text-foreground-500 text-sm">
                  <i className="ri-close-line text-foreground-300 mt-0.5 shrink-0"></i>
                  {item}
                </li>
              ))}
            </ul>
          </div>

          {/* Reddit/TikTok */}
          <div className="rounded-2xl bg-background-50 p-6 md:p-7 flex flex-col">
            <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-semibold w-fit mb-4">
              <i className="ri-global-line text-xs"></i>
              Reddit/TikTok
            </span>
            <h3 className="text-foreground-900 font-bold text-xl mb-3">Conteúdo Disperso</h3>
            <p className="text-foreground-500 text-sm mb-6 leading-relaxed">
              Informações espalhadas em redes sociais e fóruns, difíceis de encontrar e sem indexação no Google.
            </p>
            <div className="mt-auto bg-background-100 rounded-xl p-4">
              <img
                src="https://readdy.ai/api/search-image?query=Multiple%20smartphones%20showing%20different%20social%20media%20apps%20and%20forum%20threads%20scattered%20on%20bed%2C%20late%20night%20scrolling%20atmosphere%2C%20dark%20bedroom%20with%20phone%20screen%20glow%20illuminating%20face%20area%2C%20messy%20digital%20consumption%2C%20social%20media%20overload%20concept%2C%20blue%20screen%20light%20in%20dark%20room%2C%20modern%20digital%20addiction%20lifestyle%20photography%2C%20scattered%20devices%20composition&width=500&height=350&seq=comp-v2-social&orientation=landscape"
                alt="Conteúdo disperso em redes sociais"
                className="w-full h-48 object-cover object-top rounded-lg"
                loading="lazy"
              />
            </div>
            <ul className="mt-5 space-y-2.5">
              {[
                'Conteúdo desorganizado',
                'Sem indexação no Google',
                'Informações desatualizadas',
                'Difícil de encontrar',
                'Sem guias ou tutoriais',
                'Comunidade fragmentada',
              ].map((item, i) => (
                <li key={i} className="flex items-start gap-2.5 text-foreground-500 text-sm">
                  <i className="ri-close-line text-foreground-300 mt-0.5 shrink-0"></i>
                  {item}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}